<template>

  <div class="container" v-cloak>
    <div class="main-in">
      <div is='titlebox' :nav='JSON.parse(nav)'></div>
      <div class="content">

        <div class="min-h">
          <div class="f-row-l align-start">
            <div class="navbox mt22">
              <div class="defbtn" :class="ind==act?'brief':''" v-for='(item,ind) in brief2' :key="ind"
                   @click="btn(item,ind)">{{ item.label }}
              </div>
            </div>
            <div :class="brief2.length>0?'words-r':'w-100'">
              <ul v-if='$route.query.type=="12"||$route.query.type=="13"'>
                <li v-for="(item, i) in personList" :key="i">
                  <div class="f-row-l align-start pinter mt-1 w-100">
                    <div class="headbox f-row-c">
                      <img :src="item.memberImg?$imgUrl+item.memberImg:'../../assets/img/photo1.png'"/>
                    </div>
                    <div class="txt" :title="item.title" @click="Xx(item)">
                      <div class="font-w">{{ item.memberName ? item.memberName : '' }}</div>
                      <div class="">{{ $util.overfElli(item.memberIntroduce ? item.memberIntroduce : '暂无介绍', 100) }}
                      </div>
                    </div>
                  </div>

                </li>
              </ul>
              <div v-else>
                <ul v-for="(item, i) in material" :key="i"
                    :title="item.title?item.title:''||item.pictureTitle?item.pictureTitle:''">
                  <li @click="Xx(item)" class="pinter overf-elli pr act-h">
                    <div class="triangle"></div>
                    {{ item.title ? item.title : '' || item.pictureTitle ? item.pictureTitle : '' }}
                    <span>{{ item.createTime ? item.createTime : '' }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <div class="block">
          <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="param.pageNo"
              :page-size="param.pageSize"
              layout="prev, pager, next, jumper"
              :total="param.total">
          </el-pagination>
        </div>
      </div>
    </div>
    <!--  -->
  </div>

</template>
<script>
import {lists} from '@/axios/api';
import workNews from '@/views/news/workNews.vue';
import partyService from '@/views/news/partyService.vue';
import focusYouth from '@/views/news/focusYouth.vue';
import youthVolunteer from '@/views/news/youthVolunteer.vue';
import fileInfo from '@/views/news/fileInfo.vue';

export default {
  components: {workNews, partyService, focusYouth, youthVolunteer, fileInfo},
  computed: {
    nav: function () {
      var tier = 1;
      var type = this.$route.query.type
      if ((type >= 14) && (type <= 32) && type != 24 && type != 31) {
        tier = 2
      }
      if ((type >= 36) && (type <= 48)) {
        tier = 2
      }
      var arr = this.$util.getTopNav(this.title, this.$route.query.type, this.$route.query.isPrivate, tier)
      return JSON.stringify(arr)
    }
  },
  data() {
    return {
      material: [],
      personList: [],
      brief2: [],
      act: 0,
      type: this.$route.query.type,
      title: '',
      param: {
        pageNo: 1,//分页
        pageSize: 10,
        total: 0,
      }
    }
  },
  mounted() {
    this.typeIs();
  },
  watch: {
    $route(to, from, next) {
      if (to.path.indexOf('/news') != -1) {
        this.type = this.$route.query.type;
        this.param.pageNo = 1
        this.typeIs();
      }
    },
  },
  methods: {
    btn(item, ind) {
      // this.$util.goTop()
      this.act = ind
      this.type = item.slotTitle
      this.title = this.$util.getTitle(this.type)
      this.$router.push({path: '/news', query: {type: this.type}});

    },
    typeIs() {
      this.material = [];
      this.brief2 = [];
      this.title = this.$util.getTitle(this.type)

      switch (this.type * 1) {
        case 1: //'时政要闻';
          this.param.msgType = 0;
          break;
        case 2://'通知公告';
          this.param.msgType = 4;
          break;
        case 3: //'工作要讯';
          this.param.msgType = 1;
          break;
        case 4: //'聚焦青年';
          this.param.msgType = 17;
          break;
        case 5: //'文件资料';
          // this.param.msgType=3;
          this.param.msgType = 20;
          break;
        case 6: //'专题活动';
          this.param.pictureType = 0;
          break;
        case 7: //精彩图集;
          this.param.pictureType = 1;
          break;
        case 8:  //'省级团委动态';
          this.param.msgType = 5;
          break;
        case 9://'市级团委动态'
          this.param.msgType = 6;
          break;
        case 10://'县级团委动态'
          this.param.msgType = 7;
          break;
        case 31://'县级团委动态'
          this.param.msgType = 25;
          break;
        case 11://'预决算公开'
          this.param.msgType = 16;
          break;
        case 12://'优秀五四青年'
          this.param.memberType = 0;
          break;
        case 13://'优秀团干部'
          this.param.memberType = 1;
          break;
        case 14://党建服务》宣传教育
          this.param.msgType = 8
          break;
        case 15://党建服务》活动专题
          this.param.specialId = this.$route.query.id;
          break;
        case 16://党建服务》党风廉政
          this.param.msgType = 9
          break;
        case 17://党建服务》党务知识
          this.param.msgType = 10
          break;
        case 18://党建服务》规章制度
          this.param.msgType = 11
          break;
        case 19://党建服务》学习园地
          this.param.msgType = 12
          break;
        case 20://聚焦青年》青年大学习
          this.param.msgType = 13
          break;
        case 21://聚焦青年》青年发展规划
          this.param.msgType = 14;
          break;
        case 22://志愿青春》媒体聚焦
          this.param.msgType = 15
          break;
        case 23://聚焦青年》青年说
          this.param.msgType = 2
          break;
        case 24://维权服务
          break;
        case 25://团省委工作动态  //所属于：工作动态
          this.param.msgType = 23
          break;
        case 26://基层组织工作动态 //所属于：工作动态
          this.param.msgType = 21
          break;
        case 27://青海青少年研究 //所属于：文件资料
          this.param.msgType = 18
          break;
        case 28://热点新闻 //所属于：青年志愿者-志愿青春
          var businessId = ''
          break;
        case 29://热点新闻 //所属于：青年志愿者-志愿青春
          var businessId = 'QH_ZYZ'
          break;
        case 30://热点新闻 //所属于：青年志愿者-志愿青春
          var businessId = 'GR_ZYZ'
          break;
        case 33://热点新闻 //所属于：青年志愿者-志愿青春
          this.param.msgType = 40
          break;
        case 34://热点新闻 //所属于：青年志愿者-志愿青春
          this.param.msgType = 41

          break;
        case 35://热点新闻 //所属于：青年志愿者-志愿青春
          this.param.msgType = 42

          break;
        // case 36://热点新闻 //所属于：青年志愿者-志愿青春
        //   this.param.msgType = this.$route.query.id
        //   break;
      }
      
      if (this.type == 6 || this.type == 7) {
        this.getList();
      } else if (this.type == 12 || this.type == 13) { //12优秀五四青年 13优秀团干部
        this.getPersonList();
      } else if (28 <= this.type && this.type <= 30) {
        this.getZYList(businessId)
      } else if (this.type >= 36&&this.type <= 48) {//文件资料
        this.param.msgType = this.$route.query.id
        this.getFilelist()
      } else if (this.type == 15) {
        this.getActivity()
      } else if (this.type == 33 || this.type == 34 || this.type == 35) {
        this.getnewArr()
      } else {
        this.lists();
      }
    },
    getnewArr(){
      this.$get('/web/home/queryInfoList', this.param).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    getActivity() {
      this.$get('/web/home/itemList', this.param).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    // todo 文件资料列表接口
    getFilelist() {
      this.material = []

      this.$get('/web/information/list', this.param).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    handleSizeChange(val) {
      this.$util.goTop()
      // console.log(`每页 ${val} 条`);
      this.param.pageSize = val;
      this.typeIs();
    },
    handleCurrentChange(val) {
      this.$util.goTop()
      // console.log(`当前页: ${val}`);
      this.param.pageNo = val;
      this.typeIs();
    },
    Xx(item) {
      if (this.type == 27) { //青少年研究
        var url = this.$baseUrl + '/sys/common/pdf/pdfPreview?filePath=' + item.file
        var link = document.createElement('a')
        link.style.display = 'none'
        link.href = url
        link.target = '_blank'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        return
      }
      this.$util.goTop()
      this.$router.push(`/newDetail?type=${this.type}&id=${item.id}`);
    },
    getZYList(msg) {//志愿者项目接口
      this.material = []
      this.$axios.get(this.$apiUrlZY + `api/external/rootList?businessId=${msg}&pageNo=${this.param.pageNo}&pageSize=${this.param.pageSize}`).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    getPersonList() {//12优秀五四青年 13优秀团干部memberType
      delete this.param.pictureType
      delete this.param.msgType
      this.material = []

      this.$get('/web/member/list', this.param).then(res => {
        this.personList = res.result.records;
        this.param.total = res.result.total
      })
    },
    getList() {//6专题活动7精彩图集15党建服务》活动专题 pictureType
      delete this.param.memberType
      delete this.param.msgType
      this.material = []
      this.$get('/web/home/getLasBatchList', this.param).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
    lists() {//msgType
      delete this.param.memberType
      delete this.param.pictureType
      this.material = []
      this.$get('/web/information/list', this.param).then(res => {
        this.material = res.result.records;
        this.param.total = res.result.total
      })
    },
  },


}
</script>
<style lang="scss" scoped>
.headbox {
  // background: #F1F1F1;
  width: 80px;
  height: 112px;
  overflow: hidden;
  margin-right: 10px;

  img {
    max-width: 100%;
    max-height: 100%;
  }
}

.txt {
  width: calc(100% - 90px);

  .font-w {
    font-weight: 600;
    margin-bottom: 10px;
  }
}

.content {
  width: calc(100% - 100px);
  margin: auto;

  ul {
    width: 100%;

    .pr {
      padding-right: 180px;
    }

    li {
      width: 100%;
      list-style: none;
      text-align: left;
      display: inline-block;
      line-height: 25px;
      padding-bottom: 15px;
      border-bottom: 1px dashed #E0E0E0;
      font-size: 16px;
      font-weight: 400;
      color: #333333;

      position: relative;

      span {
        font-size: 14px;
        color: #999999;
        position: absolute;
        right: 20px;
        font-weight: 100;
      }
    }
  }

  .block {
    text-align: center;
    line-height: 50px;
    margin-top: 20px;
  }

  .defbtn, .brief {
    margin-top: 0;
  }
}
</style>